<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.documentMgmt") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>{{ $t("management.documentType") }}</th>
            <td colspan="5">
              <ul class="group_sel_ul">
                <li>
                  <!-- <em>대분류</em> -->
                  <select v-model="form.doctypeId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(doc, index) in doctypeList"
                      :key="index"
                      :value="doc.doctypeId"
                    >
                      {{ doc.doctypeName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.productType") }}</th>
            <td colspan="5">
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.upperProdId"
                    class="int_type01 mgt_seltype"
                    @change="getSubProducts(form.upperProdId)"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(prod, index) in mainProd"
                      :key="index"
                      :value="prod.prodId"
                    >
                      {{ prod.prodName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.subCategory") }}</em>
                  <select v-model="form.prodId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(subProd, index) in subProductType"
                      :key="index"
                      :value="subProd.prodId"
                    >
                      {{ subProd.prodName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.language") }}</th>
            <td>
              <select v-model="form.lang" class="int_type01 mgt_seltype">
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
            <th>{{ $t("common.date") }}</th>
            <td colspan="3" class="d-flex">
              <!-- <input type="date" class="int_type01 mgt_seltype" v-model="form.startDate" title="작성일"> ~ 
                <input type="date" class="int_type01 mgt_seltype" v-model="form.endDate" title="작성일"> -->
              <b-form-datepicker
                v-model="form.startDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                @input="checkDate"
                style="height: 20px; border-radius: 0px"
                label-no-date-selected=""
              ></b-form-datepicker>
              <span style="margin: 5px; margin-top: 15px">~</span>
              <b-form-datepicker
                v-model="form.endDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                aria-controls="example-input"
                placeholder="YYYY-MM-DD"
                @input="checkDate"
                style="height: 20px; border-radius: 0px"
                label-no-date-selected=""
              ></b-form-datepicker>
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.document") }}</th>
            <td colspan="5">
              <input
                type="text"
                v-model="form.searchWord"
                @keyup.enter="searchBtn"
                class="int_type01 mgt_seltype"
                title="Search Document Name"
                style="width: 100%"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mgt_option_bottom">
        <button @click="searchBtn" class="btn btn-primary">
          {{ $t("common.search") }}
        </button>
      </div>
    </div>
    <div class="mgt_option_bottom">
      <router-link to="/management/library/document/new" class="btn btn-primary">{{
        $t("common.add")
      }}</router-link>
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </div>
    <table class="list_tbl">
      <thead>
        <tr>
          <th class="mobile_row">
            {{ $t("product.documentType")
            }}<span class="mobile_vt"
              >/ {{ $t("support.notice.classify") }} / {{ $t("support.notice.writer") }} /
              {{ $t("support.notice.date") }} / {{ $t("support.notice.file") }}</span
            >
          </th>
          <th class="mobile_h">{{ $t("common.documentName") }}</th>
          <th class="mobile_h">{{ $t("product.distribute") }}</th>
          <th class="mobile_h">{{ $t("common.language") }}</th>
          <th class="mobile_h">{{ $t("support.notice.date") }}</th>
        </tr>
      </thead>
      <tbody v-if="docList.length != 0">
        <tr v-for="(item, index) in docList" :key="index">
          <td>{{ item.doctypeName }}</td>
          <td class="text-left" v-if="item.modelName != 'None'">
            <router-link
              :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId , searchForm : form} }"
              ><span v-if="item.modelName != null && item.modelName.length< 20" >[{{  item.modelName }}]</span> 
               <span v-else-if="item.modelName != null && item.modelName.length > 20" >[{{  item.modelName.substring(0, 20) }} ...]</span>
              {{ item.docTitle }}
            </router-link>
          </td>
          <td class="text-left" v-else>
            <router-link
              :to="{ name: 'mgmtDocumentDtails', params: { docId: item.docId, searchWord : form.searchWord , page: form.page } }"
              >{{ item.docTitle }}</router-link
            >
          </td>          
          <td v-if="item.publishedYn == 'Y'">{{ $t("product.distribute") }}</td>
          <td v-else>{{ $t("product.unDistribute") }}</td>
          <td>{{ item.langName }}</td>
          <td>{{ item.firstRegDatetime | moment("YYYY-MM-DD") }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="5">{{ $t("common.noData") }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="docList.length != 0" class="paging_nav">
      <div class="paging_nav">
        <a
          href="#"
          v-if="pagingVO.startPage <= pagingVO.blockSize"
          class="page_select prev_page disabled"
          >이전페이지 이동</a
        >
        <a
          v-else
          class="page_select prev_page"
          @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
          v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
          >이전페이지 이동</a
        >
        <span
          v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
          :key="index"
        >
          <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
            pagingVO.startPage + index
          }}</strong>
          <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
            pagingVO.startPage + index
          }}</a>
        </span>
        <a
          v-if="pagingVO.endPage >= pagingVO.totalPage"
          href="#"
          class="page_select next_page disabled"
          >다음페이지 이동</a
        >
        <a
          v-else
          href="#"
          @click="searchPage(pagingVO.endPage + 1)"
          v-bind:data-page="pagingVO.endPage + 1"
          class="page_select next_page"
          >다음페이지 이동</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { documentMgmtList, downExcel } from "@/api/document";
export default {
  data() {
    return {
      docId: "",
      docList: [],
      doctypeList: [],
      versionList: [],
      mainProd: "",
      subProductType: "",
      langList: "",
      pagingVO: "",
      form: {
        doctypeId: "",
        prodId: "",
        userId: "",
        upperProdId: "",
        startDate: "",
        endDate: "",
        searchWord: "",
        searchState: "",
        publishedYN: "",
        lang: "",
        page: 1,
      },
    };
  },
  mounted() {
    var searchForm = this.$route.params.searchForm;
    if(searchForm){
      this.form = searchForm;
    }
    this.fetchData(this.form);
  },
  methods: {
    // 분류조회
    async fetchData(form) {
      try {
        let loader = this.$loading.show({});
        const resp = await documentMgmtList(form);
        this.docList = resp.data.pagingVO.dataList;
        this.pagingVO = resp.data.pagingVO;
        this.doctypeList = resp.data.doctypeList;
        this.mainProd = resp.data.mainProd;
        this.subProd = resp.data.subProd;
        this.langList = resp.data.langList;
        loader.hide();
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData(this.form);
    },
    searchBtn() {
      this.form.page = 1;
      this.fetchData(this.form);
    },
    getAll() {
      this.fetchData(this.form);
    },
    // 대분류 선택시 중분류
    getSubProducts(prodId) {
      this.subProductType = [];
      for (let i in this.subProd) {
        if (prodId === this.subProd[i].upperProdId) {
          this.subProductType.push(this.subProd[i]);
        }
      }
    },
    checkDate() {
      if (this.form.endDate != "" && this.form.startDate != "") {
        if (this.form.endDate < this.form.startDate) {
          alert(this.$t("alert.checkDate"));
          this.form.endDate = "";
          this.form.startDate = "";
          return;
        }
      }
    },
    async downExcel() {
      let result = await downExcel(this.form);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "DocumentList.xls";
      link.click();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.b-form-datepicker {
  height: 35px !important;
  padding: 2px 0 15px 0;
}
.mgt_option_bottom {
  margin-bottom: 0px;
  border-bottom: 0px;
}
.brick_box {
  margin-bottom: 30px;
}
</style>
